import { groupBy, isNumber, sortBy } from 'lodash'

import events from '@/services/events'

import normalizeInventoryItem from '../../util/normalizeInventoryItem'

const resetInventory = (state) => {
  state.inventoryItems = []

  return state
}

export default {

  state: resetInventory({}),

  getters: {

    inventoryItems ({ inventoryItems }) {
      return sortBy(inventoryItems, 'type')
    },

    inventoryItemIndexesById (state, getters) {
      const indexes = {}

      getters.inventoryItems.forEach((inventoryItem, i) => {
        indexes[inventoryItem.id] = i
      })

      return indexes
    },

    inventoryItemsByType (state, getters) {
      return groupBy(getters.inventoryItems, 'type')
    },

    inventoryItemById (state, getters) {
      return (id) => {
        return getters.inventoryItems[getters.inventoryItemIndexesById[id]]
      }
    }

  },

  mutations: {

    resetInventory,

    createInventoryItem (state, inventoryItemData) {
      const inventoryItem = normalizeInventoryItem(inventoryItemData)
      state.inventoryItems.push(inventoryItem)
      events.$emit('inventoryItem:created', inventoryItem)
    },

    updateInventoryItem (state, { i, data }) {
      const inventoryItem = normalizeInventoryItem({
        ...state.inventoryItems[i],
        ...data
      })

      state.inventoryItems[i] = inventoryItem

      events.$emit('inventoryItem:updated', inventoryItem)
    },

    deleteInventoryItem (state, i) {
      const inventoryItem = state.inventoryItems[i]
      if (inventoryItem) {
        state.inventoryItems.splice(i, 1)
        events.$emit('inventoryItem:deleted', inventoryItem)
      }
    }

  },

  actions: {

    spawnInventoryItem ({ commit }, inventoryItem) {
      commit('createInventoryItem', inventoryItem)
    },

    destroyInventoryItemById ({ commit, getters }, id) {
      if (isNumber(getters.inventoryItemIndexesById[id])) {
        commit('deleteInventoryItem', getters.inventoryItemIndexesById[id])
      }
    }

  }

}
